import request from "./http";
import { TRANSFERENCIAS_ENDPOINT } from "../infrastructure/appConstants";

const transferenciaService = {
  transferenciaCuentasPropiasValidar: (req) =>
    request.post(
      `${TRANSFERENCIAS_ENDPOINT}/validar/transferencia-propia`,
      req
    ),
  transferenciaCuentasPropiasConfirmar: (req) =>
    request.post(
      `${TRANSFERENCIAS_ENDPOINT}/transferir/transferencia-propia`,
      req
    ),
  transferenciaCuentasPrymeraValidar: (req) =>
    request.post(
      `${TRANSFERENCIAS_ENDPOINT}/validar/transferencia-prymera`,
      req
    ),
  transferenciaCuentasPrymeraConfirmar: (req) =>
    request.post(
      `${TRANSFERENCIAS_ENDPOINT}/transferir/transferencia-prymera`,
      req
    ),
  transferenciaCuentasIfisValidar: (req) =>
    request.post(`${TRANSFERENCIAS_ENDPOINT}/validar/transferencia-ifis`, req),
  transferenciaCuentasIfisConfirmar: (req) =>
    request.post(
      `${TRANSFERENCIAS_ENDPOINT}/transferir/transferencia-ifis`,
      req
    ),
  listarBancosTransferencias: () =>
    request.get(`${TRANSFERENCIAS_ENDPOINT}/listar/bancos`),
};

export default transferenciaService;
